// Static Routes
export const supportRoute = '/support';
export const homeRoute = '/';
export const aboutRoute = '/about';
export const contactRoute = '/contact';
export const iconfaqsRoute = '/iconfaq';
export const helpRoute = '/help';
export const codeDefinitionsRoute = '/support/codedefinitions';
export const relNotesRoute = '/support/relnotes';
export const resourcesRoute = '/support/resources';
export const gettingStartedRoute = '/support/gettingStarted';
export const newslettersRoute = '/support/newsletters';
export const loginRoute = '/login';
export const loginFailureRoute = '/loginFailure';
export const registrationRoute = '/register';
export const invitationRoute = '/invitation';
export const registrationGuideRoute = '/registration-guide';
export const subscriptionPlansRoute = "/billsby/subscription-plans"
export const termsOfUseRoute = '/terms-of-use';
// export const tutorialsRoute = '/support/tutorials';
// export const findSpecRoute = '/support/findspec';
// export const howToRoute = '/support/howto';
// export const successStoriesRoute = '/about/stories';
// export const privacyRoute = '/privacy';
// export const pnHelpFilesRoute = '/support/addingnewpn';

// Feature routes for Home page (aliases to existing routes)
export const salesOpportunitiesRoute = '/static/SalesOpportunities/SalesOpportunities';
export const toolingRecordsRoute = '/static/ToolingRecords/ToolingRecords';
export const supplierDatabaseRoute = '/static/SupplierDatabase/SupplierDatabase';
export const growBusinessRoute = '/static/GrowBusiness/GrowBusiness';

// External Routes
export const facebookRoute = 'https://www.facebook.com/NFFSICON';
export const instagramRoute = 'https://www.instagram.com/explore/locations/324088417686882/non-ferrous-founders-society/';
export const youtubeRoute = 'https://www.youtube.com/channel/UCin4Qs1EM__EkkGLWtRJQYw';
export const twitterRoute = 'https://twitter.com/INsrayburn';

export const nffsRoute = 'https://nffs.org/';
export const dlaRoute = 'https://www.dla.mil/';
export const dodRoute = 'https://www.defense.gov/';
export const ntmaRoute = 'https://ntma.org/';
export const iciRoute = 'https://www.investmentcasting.org/';
export const afCatRoute = 'https://www.dla.mil/Aviation/Offers/Services/AviationEngineering/Engineering/CastForg.aspx';
export const metalFactRoute = 'https://www.dla.mil/LandandMaritime/Offers/Services/TechnicalSupport/ValueMgtDiv.aspx';
export const castItRoute = 'https://amc.ati.org/cast-it/';
export const fiaRoute = 'https://www.forging.org/';

// Search Solicitation Routes
export const solicitationsSearchRoute = '/solicitations'; // 
export const solicitationsShowRoute = '/solicitations/:solicitationId'; // 

// Search Tooling LocationsRoutes
export const toolingLocationListRoute = '/tools/locator'; // 
export const toolingLocationRoute = '/tools/locator/:toolId'; // Probably outdated

// Search Procurement History Routes
// export const procurementHistoryRoute = '/history/search'; // 

// Search Supplier capabilities
export const supplierCapabilitiesRoute = '/suppliers'; //
// export const supplierSearchResults = '/supplier/results';

// Universal Details Page
export const universalDetailsRoute = '/details'; // 

// message Center routes
export const messageCenterRoute = '/messagecenter';
// export const ViewMessagesRoute = '/messagecenter/:messageId';
// export const composeMessageRoute = '/messageCenter/compose';

// Contract Center Routes
export const contractCenterRoute = '/contractcenter'; //
export const contractRfqRoute = '/contractcenter/RFQ'; //
export const contractQuoteRoute = '/contractcenter/quote'; //
export const viewQuoteRoute = '/contractcenter/review';
export const DibbsRFQWizardRoute = '/contractcenter/DIBBS';

// Tooling Management Routes
export const toolingManagementRoute = '/memberadmin/toolingmanagement/:page'; //
// export const downloadToolingRoute = '/toolingmanagement/downloadtooling';
// export const editToolingRoute = '/memberadmin/edittooling/:toolingId'; // pop up now
// export const orgToolingRoute = '/memberadmin/viewproducts'; // no
// export const addProductRoute = '/memberadmin/addproduct';
// export const addToolingRoute = '/toolingmanagement/addtooling'; // no
// export const uploadToolingRoute = '/toolingmanagement/uploadtooling'; // no
// export const editToolingManagementRoute = '/memberadmin/edittoolingmanagement/:toolingId';

// Inventory Management Routes
export const inventoryManagementRoute = '/memberadmin/inventorymanagement/:page'; //
// export const addInventoryRoute = '/inventorymanagement/addinventory';
// export const uploadInventoryRoute = '/inventorymanagement/uploadinventory'; // no
// export const editInventoryManagementRoute = '/inventorymanagement/editinventorymanagement/:inventoryId';

// Member Admin Routes
export const accountAdminRoute = '/memberadmin/home/:page'; //
export const accountAdminSubscription = 'memberadmin/home/updateSubscription';
// export const bidMatchingRoute = '/memberadmin/bidmatching'; //
// export const addUserRoute = '/memberadmin/adduser'; //
// export const editUserRoute = '/memberadmin/edituser/:userId'; //
// export const editDemographicsRoute = '/memberadmin/demographics'; // no
// export const viewUsersRoute = '/memberadmin/home/viewUsers'; // is page of home
// export const updatePdmiPasswordRoute = '/memberadmin/pdmipasswd'; // no
// export const folderAdminRoute = '/memberadmin/folderadmin'; // no
// export const updateSupplierRoute = '/memberadmin/updtsupplierdb'; // no

// Super Admin Routes
export const superAdminHomeRoute = '/superadmin/home/:page'; //
// export const superAdminEditOrgRoute = '/superadmin/edit/organization/:id'; //
// export const superAdminRoute = '/superadmin';
// export const userSearchRoute = '/superadmin/usersearch';
// export const addEntityRoute = '/superadmin/home/addOrganization'; 
// export const viewEntitiesRoute = '/superadmin/viewentities';
// export const managePendingRequestsRoute = '/superadmin/pendingreq';
// export const rejectedSignupsRoute = '/superadmin/rejected';
// export const activityLogsRoute = '/superadmin/viewlogs';
// export const manageHowToRoute = '/superadmin/howto';
// export const manageLicensingAgreementsRoute = '/superadmin/updtlicagmts';
// export const manageSpecsRoute = '/superadmin/viewspecs';
// export const manageSourcesRoute = '/superadmin/viewsources';

// Solicitation Folders
// export const inboxRoute = '/members/folders/show/inbox';
// export const flaggedSolRoute = '/members/folders/show/flagged';
// export const cancelledSolRoute = '/members/folders/show/cancelled';
// export const archiveSolRoute = '/members/folders/show/archive';
// export const inProcesSolRoute = '/members/folders/show/in%20process';
// export const companyRoute = '/members/folders/show/{company}';
// export const trashSolRoute = '/members/folders/show/trash';

// // Search Casting Db
// export const searchCastingDbRoute = '/tools/search';

// // Search Tooling Database
// export const searchToolingRoute = '/membertools/toolinglocator';

// My Account Routes
// export const myAccountRoute = '/myaccount';
// export const userPreferencesRoute = '/myaccount/preferences';
// export const changePasswordRoute = '/myaccount/changepassword';
export const pdmiCredentialsRoute = '/myaccount/pdmi'; // Propbably outdated

export const paymentHistoryRoute = '/memberadmin/home/paymentHistory';

export const privacyPolicyRoute = '/privacy-policy';

export const section508Route = '/section-508';



// WEBPACK FOOTER //
// ./src/config/navigation/routes.js